import {AbstractModel} from '../abstract-model';
import {Offer} from '../offer';
import {Currency} from '../currency';

export class ConversionReport extends AbstractModel {
  id: number | null = null;
  offer: Offer | null = null;
  date: string = '';
  revenue: number = 0;
  currency: Currency | null = null;
  tc1: string = '';
  tc2: string = '';
  tc3: string = '';
  tc4: string = '';

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.currency) {
      this.currency = new Currency().deserialize(input.currency);
    }

    return this;
  }

  getDate(): Date {
    return new Date(this.date);
  }

  override toString(): string {
    return this.date;
  }
}
